<template>
    <div class="rating" @mouseleave="hoverRating = 0">
        <span
            v-for="(star, index) in maxRating"
            :key="index"
            @click="rate(index + 1)"
            @mouseover="handleHover(index + 1)"
            :class="{ editable }"
        >
            <i :style="{fontSize: size}" :class="getStarClass(index)"></i>
        </span>
    </div>
</template>

<script>
export default {
    props: {
        modelValue: {
            type: Number,
            default: 0
        },
        editable: {
            type: Boolean,
            default: false
        },
        maxRating: {
            type: Number,
            default: 5
        },
        size: {
            type: String,
            default: '24px'
        }
    },
    data() {
        return {
            hoverRating: 0
        }
    },
    methods: {
        rate(rating) {
            if (this.editable) {
                this.$emit('update:modelValue', rating)
            }
        },
        handleHover(rating) {
            if (this.editable) {
                this.hoverRating = rating
            }
        },
        getStarClass(index) {
            const current = this.hoverRating || this.modelValue
            return index < current ? 'fas fa-star hovered' : 'far fa-star'
        }
    }
}
</script>

<style scoped>
.rating {
    display: flex;
}

.rating span {
    margin: 0 5px;
    cursor: default;
}

.rating span.editable {
    cursor: pointer;
}

.rating i {
    transition: color 0.2s ease;
    color: #ccc;
}

.rating i.fas.fa-star {
    color: #ffd700;
}

.rating i.fas.fa-star.hovered {
    color: #ffec80; /* Color más claro al hacer hover */
}
</style>
